var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69 3.62C5.19 3.62 4.09 4.52 4.09 5.93H5.27C5.3 5.11 5.78 4.58 6.67 4.58C7.3 4.58 7.83 4.9 7.83 5.47C7.83 6.04 7.4 6.41 6.82 6.76C6.08 7.21 5.69 7.63 5.69 8.56V8.9H6.88V8.59C6.88 7.93 7.17 7.73 7.79 7.35C8.4 6.98 9.05 6.34 9.05 5.4C9.05 4.18 7.88 3.62 6.69 3.62ZM6.97 11V9.64H5.61V11H6.97Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.f24fb0e5d918a304166cef150c334476.svg";
export { ForwardRef as ReactComponent };